import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = ({ title, subtitle, backgroundImage, showCta, ctaText, ctaLink }) => (
  <section className="hero" style={{ backgroundImage: `url(${backgroundImage})` }}>
    <div className="hero__overlay" />
    <div className="hero__content container">
      <h1 className="hero__title">{title}</h1>
      {subtitle && <p className="hero__subtitle">{subtitle}</p>}
      {showCta && <Link to={ctaLink} className="btn btn-primary">{ctaText}</Link>}
    </div>
  </section>
);

export default Hero;
